import React, { useState, ChangeEvent, FormEvent, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  Paper,
  FormControl,
  InputAdornment,
  IconButton,
  Modal,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  CircularProgress
} from '@mui/material';
import Heading from '../../Components/Heading/heading.tsx';
import ItemDetailsForm from './item-details-form.tsx';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MapModal from '../../Pages/Warehouses/map-modal.tsx';
import { getPincode, getCustomerDetails } from './action.ts';
import { toast } from 'react-toastify';
interface SingleOrderModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (formData: FormData) => void;
  items: any;
  setItems: React.Dispatch<React.SetStateAction<any>>;
  currentItem: any;
  setCurrentItem: React.Dispatch<React.SetStateAction<any>>;
  showGst: boolean;
  setShowGst: React.Dispatch<React.SetStateAction<boolean>>;
  weight: string;
  setWeight: React.Dispatch<React.SetStateAction<string>>;
  crates: string;
  setCrates: React.Dispatch<React.SetStateAction<string>>;
  cod: string;
  setCod: React.Dispatch<React.SetStateAction<string>>;
  logisticsCost: string;
  setLogisticsCost: React.Dispatch<React.SetStateAction<string>>;
  grandTotal:string;
  setGrandTotal: React.Dispatch<React.SetStateAction<string>>;
  dimensions: any;
  setDimensions: React.Dispatch<React.SetStateAction<any>>;
  deliveryType: any;
  setDeliveryType: React.Dispatch<React.SetStateAction<any>>;
  step:string;
  setStep: React.Dispatch<React.SetStateAction<'order' | 'item'>>;
  formData: FormData;
  setFormData: (formData: FormData) => void;  
}
interface FormData {
  orderId: string;
  date: string;
  name: string;
  pincode: string;
  address: string;
  cityState: string;
  mobile: string;
  email: string;
  latitude: string;
  longitude: string;
}
interface CustomerAddress {
  id: string;
  address: string;
  pincode: string;
  city: string | null;
  state: string;
  email: string;
  longitude: string | null;
  latitude: string | null;
  name: string;
}

const SingleOrderModal: React.FC<SingleOrderModalProps> = ({ 
  open, onClose, onSubmit, items,
  setItems,
  currentItem,
  setCurrentItem,
  showGst,
  setShowGst,
  weight,
  setWeight,
  crates,
  setCrates,
  cod,
  setCod,
  logisticsCost,
  setLogisticsCost,
  grandTotal,
  setGrandTotal,
  dimensions,
  setDimensions,
  step,setStep, formData,
  setFormData,deliveryType,setDeliveryType
}) => {

  const [errors, setErrors] = useState<Partial<FormData>>({});
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [orderData, setOrderData] = useState<any>({});
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [latitudeError, setLatitudeError] = useState<string>('');
  const [longitudeError, setLongitudeError] = useState<string>('');
  const [isLoadingPincode, setIsLoadingPincode] = useState(false);
  const [addressModalOpen, setAddressModalOpen] = useState(false);
  const [customerAddresses, setCustomerAddresses] = useState<CustomerAddress[]>([]);
  const [isLoadingCustomer, setIsLoadingCustomer] = useState(false);
  const [prevMobileLength, setPrevMobileLength] = useState(0);
  const [selectedCustomerId, setSelectedCustomerId] = useState<string>('');
  const [isNewAddress, setIsNewAddress] = useState<boolean>(true);
  const [isExistingCustomer, setIsExistingCustomer] = useState<boolean>(false);
  const [originalAutopopulatedData, setOriginalAutopopulatedData] = useState<Partial<FormData>>({});
  const [hasModifiedAutopopulatedData, setHasModifiedAutopopulatedData] = useState(false);

  const validateName = (name) => {
    if (!name.trim()) return 'Name is required';
    if (!/^[a-zA-Z\s.]*$/.test(name)) return 'Name can only contain letters, spaces, and dots';
    return '';
  };

  const validatePhone = (phone) => {
    if (!phone.trim()) return 'Phone number is required';
    if (!/^\d{10}$/.test(phone)) return 'Phone number must be exactly 10 digits';
    return '';
  };

  const validatePincode = (pincode) => {
    if (!pincode.trim()) return 'Pincode is required';
    if (!/^\d{6}$/.test(pincode)) return 'Pincode must be exactly 6 digits';
    return '';
  };

  const validateLatLong = (value, field) => {
    if (value && !/^-?\d*\.?\d*$/.test(value)) {
       return `${field}Invalid Value`;
    }
    return '';
  };

  const validateEmail = (email) => {
    if (!email.trim()) return 'Email is required';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'Please enter a valid email address';
    return '';
  };
  const resetAllFields = () => {
    setFormData({
      orderId: '',
      date: new Date().toISOString().split('T')[0],
      name: '',
      pincode: '',
      address: '',
      cityState: '',
      mobile: '',
      email: '',
      latitude: '',
      longitude: ''
    });
    setItems([]);
    setCurrentItem({
      skuId: '',
      item: '',
      description: '',
      rate: '',
      quantity: '',
      total: '0.00',
      hsnCode: '',
      igst: '',
      cgst: '',
      sgst: '',
      discount: ''
    });
    setShowGst(false);
    setWeight('');
    setCrates('');
    setCod('');
    setLogisticsCost('');
    setGrandTotal('');
    setDimensions({
      length: '',
      breadth: '',
      height: ''
    });
    setStep('order');
    setCity('');
    setState('');
    setErrors({});
    setLatitudeError('');
    setLongitudeError('');
    setDeliveryType('');
    setCustomerAddresses([]);
    setSelectedCustomerId('');
    setIsNewAddress(true);
    setIsExistingCustomer(false);
    setOriginalAutopopulatedData({});
    setHasModifiedAutopopulatedData(false);
    onClose();
  };
  const formatDateTime = (date: Date) => {
    const pad = (num: number) => String(num).padStart(2, "0");
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    if (open) {
      const now = new Date();
      setFormData(prev => ({
        ...prev,
        date: formatDateTime(now),
        mobile: prev.mobile || "",
        orderId: prev.orderId || ""
      }));
      setPrevMobileLength(formData.mobile.length);
      setIsExistingCustomer(false);
      setIsNewAddress(true);
    }
  }, [open]);

  const validateForm = () => {
    const newErrors = {};
    newErrors.orderId = !formData.orderId.trim() ? 'Order ID is required' : '';
    if (isNewAddress) {
      newErrors.name = validateName(formData.name);
      newErrors.pincode = validatePincode(formData.pincode);
      newErrors.address = !formData.address.trim() ? 'Address is required' : '';
      newErrors.email = validateEmail(formData.email);
      newErrors.latitude = validateLatLong(formData.latitude, 'Latitude');
      newErrors.longitude = validateLatLong(formData.longitude, 'Longitude');
    }
    newErrors.mobile = validatePhone(formData.mobile);
    const filteredErrors = Object.fromEntries(
      Object.entries(newErrors).filter(([_, value]) => value !== '')
    );
    setErrors(filteredErrors);
    return Object.keys(filteredErrors).length === 0;
  };

  useEffect(() => {
    if (formData.pincode.length === 6 && isNewAddress) {
      fetchPincodeDetails(formData.pincode);
    }
  }, [formData.pincode]);

  useEffect(() => {
    if (prevMobileLength === 10 && formData.mobile.length < 10) {
      setFormData(prev => ({
        ...prev,
        name: '',
        email: '',
        address: '',
        pincode: '',
        cityState: '',
        latitude: '',
        longitude: ''
      }));
      setCity('');
      setState('');
      setCustomerAddresses([]);
      setIsExistingCustomer(false);
      setIsNewAddress(true);
    }
    setPrevMobileLength(formData.mobile.length);
    if (formData.mobile.length === 10) {
      fetchCustomerDetails(formData.mobile);
    } else {
      setCustomerAddresses([]);
      setIsExistingCustomer(false);
      setIsNewAddress(true);
    }
  }, [formData.mobile]);

const fetchCustomerDetails = (phoneNumber: string) => {
  setIsLoadingCustomer(true);
  getCustomerDetails(
    phoneNumber,
    (response) => {
      setIsLoadingCustomer(false);
      if (
        response &&
        response.message &&
        response.message.customers &&
        response.message.customers.length > 0
      ) {
        const customers = response.message.customers;
        setCustomerAddresses(customers);
        setAddressModalOpen(true);
      } else {
        setIsExistingCustomer(false);
        setIsNewAddress(true);
      }
    },
    (error) => {
      setIsLoadingCustomer(false);
      if (error.response?.status !== 404) {
        console.error(error.message || "Failed to fetch customer details");
      }
      setIsExistingCustomer(false);
      setIsNewAddress(true);
    }
  );
};

  const autoFillCustomerDetails = (customer: CustomerAddress) => {
    const autopopulatedData = {
      name: customer.name || '',
      email: customer.email || '',
      address: customer.address || '',
      pincode: customer.pincode || '',
      cityState: customer.city ? `${customer.city}, ${customer.state}` : customer.state,
      latitude: customer.latitude || '',
      longitude: customer.longitude || ''
    };
    setFormData(prev => ({
      ...prev,
      ...autopopulatedData
    }));
    setOriginalAutopopulatedData(autopopulatedData);
    setHasModifiedAutopopulatedData(false);
    setCity(customer.city || '');
    setState(customer.state || '');
    if (customer.pincode && customer.pincode.length === 6) {
      fetchPincodeDetails(customer.pincode);
    }
  };

  const hasAutopopulatedDataChanged = () => {
    if (!isExistingCustomer || !selectedCustomerId) return false;
    const fieldsToCompare = ['name', 'email', 'address', 'pincode', 'latitude', 'longitude'];
    return fieldsToCompare.some(field => {
      const currentValue = formData[field as keyof FormData];
      const originalValue = originalAutopopulatedData[field as keyof FormData];
      return currentValue !== originalValue;
    });
  };

  const handleAddressSelect = (customer: CustomerAddress) => {
    autoFillCustomerDetails(customer);
    setSelectedCustomerId(customer.id);
    setIsNewAddress(false);
    setIsExistingCustomer(true);
    setAddressModalOpen(false);
  };

  const handleAddNewAddress = () => {
    setFormData(prev => ({
        ...prev,
        name: '',
        email: '',
        address: '',
        pincode: '',
        cityState: '',
        latitude: '',
        longitude: ''
    }));
    setCity('');
    setState('');
    setSelectedCustomerId('');
    setIsNewAddress(true);
    setIsExistingCustomer(false);
    setAddressModalOpen(false);
  };

  const handleLocationSelect = (address: string, lat: string, lng: string) => {
    setFormData(prev => ({
      ...prev,
      address: address,
      latitude: lat,
      longitude: lng
    }));
    setLatitudeError('');
    setLongitudeError('');
    setMapModalOpen(false);
  };

const handleSubmit = (e: FormEvent) => {
  e.preventDefault();
  if (validateForm()) {
    const hasChanges = hasAutopopulatedDataChanged();
    let customerId = '';
    let forceNewCustomer = '';
    let isNewAddressFlag = true;
    
    if (isExistingCustomer && !hasChanges) {
      customerId = selectedCustomerId;
      forceNewCustomer = '';
      isNewAddressFlag = false;
    } else if (isExistingCustomer && hasChanges) {
      customerId = '';
      forceNewCustomer = '1';
      isNewAddressFlag = true;
    } else if (!isExistingCustomer){
      customerId = '';
      forceNewCustomer = '1';
      isNewAddressFlag = true;
    }  
    setOrderData({
      ...formData,
      customerId,
      isNewAddress: isNewAddressFlag,
      force_new_Customer: forceNewCustomer
    }); 
    setStep('item');
  }
};

  const handleItemSubmit = (data: any) => {
    const completeOrderData = { 
      ...orderData, 
      items: [...items],
      ...data 
    };
    onSubmit(completeOrderData);
  };

  const handleBack = () => {
    setStep('order');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (isExistingCustomer && 
        ['name', 'email', 'address', 'pincode', 'latitude', 'longitude'].includes(name)) {
      if (originalAutopopulatedData[name as keyof FormData] !== undefined) {
        setHasModifiedAutopopulatedData(true);
      }
    }
    if (name === 'mobile' && isExistingCustomer) {
      setIsExistingCustomer(false);
      setIsNewAddress(true);
      setHasModifiedAutopopulatedData(false);
      setOriginalAutopopulatedData({});
    }
    
    setFormData(prev => ({ ...prev, [name]: value }));
    
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
    
    if (name === 'mobile' && value.length > 10) {
      setErrors(prev => ({ ...prev, [name]: 'Mobile number cannot exceed 10 digits' }));
    }
    
    if (name === 'pincode' && value.length > 6) {
      setErrors(prev => ({ ...prev, [name]: 'Pincode cannot exceed 6 digits' }));
    }
  };

  const fetchPincodeDetails = (pincode: string) => {
    if (isLoadingPincode || (city && state)) {
      return;
    }
    
    setIsLoadingPincode(true);
    
    getPincode(
      pincode,
      (response) => {
        if (response && response.city && response.state) {
          setCity(response.city);
          setState(response.state);
          setFormData(prev => ({ 
            ...prev, 
            cityState: `${response.city}, ${response.state}` 
          }));
        } else {
          toast.error('Invalid pincode or no data found');
        }
        setIsLoadingPincode(false);
      },
      (errorMessage) => {
        toast.error(errorMessage || 'Failed to fetch pincode details');
        setIsLoadingPincode(false);
      }
    );
  };

  const handlePincodeBlur = () => {
    if (formData.pincode.length === 6 && !city && !state && isNewAddress) {
      fetchPincodeDetails(formData.pincode);
    }
  };

  const handleGoogleMapsSelect = () => {
    setMapModalOpen(true);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = '';
    
    switch (name) {
      case 'name':
        error = validateName(value);
        break;
      case 'mobile':
        if (value.length > 10) {
          error = 'Mobile number cannot exceed 10 digits';
        } else {
          error = validatePhone(value);
        }
        break;
      case 'pincode':
        if (value.length > 6) {
          error = 'Pincode cannot exceed 6 digits';
        } else {
          error = validatePincode(value);
        }
        break;
      case 'latitude':
        error = validateLatLong(value, 'Latitude');
        break;
      case 'longitude':
        error = validateLatLong(value, 'Longitude');
        break;
      case 'email':
        error = validateEmail(value);
        break;
      default:
        break;
    }
    
    if (error) {
      setErrors(prev => ({ ...prev, [name]: error }));
    }
  };

  const getTodayDate = () => {
    return new Date().toISOString().split('T')[0];
  };

  return (
    <>
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth={step === 'order' ? 'xs' : 'md'} 
        fullWidth>
        <Box sx={{ marginLeft: step === 'item' ? '-180px' : '-180px' }}>
          <Heading 
            title={step === 'order' ? "Create Single Order" : "Add Item Details"} 
            closeIcon="true" 
            onClose={onClose}
            leftContent={step === 'item' ? (
              <IconButton onClick={handleBack} sx={{ mr: 1 }}>
                <ArrowBackIcon />
              </IconButton>
            ) : null}
          />
        </Box>
        
        <DialogContent sx={{ mt: 2 }}>
          {step === 'order' ? (
            <Box component="form" onSubmit={handleSubmit}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
                <FormControl fullWidth>
                  <TextField
                    label="Order ID"
                    name="orderId"
                    size="small"
                    value={formData.orderId}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!errors.orderId}
                    helperText={errors.orderId}
                    required
                  />
                </FormControl>
                <FormControl fullWidth>
                  <TextField
                    label="Date"
                    type="date"
                    name="date"
                    size="small"
                    value={formData.date ? formData.date.split(" ")[0] : ""}
                    onChange={(e) => {
                      const selectedDate = e.target.value;
                      const now = new Date();
                      const updated = new Date(
                        Number(selectedDate.split("-")[0]),
                        Number(selectedDate.split("-")[1]) - 1,
                        Number(selectedDate.split("-")[2]),
                        now.getHours(),
                        now.getMinutes(),
                        now.getSeconds()
                      );
                      setFormData(prev => ({ ...prev, date: formatDateTime(updated) }));
                    }}
                    inputProps={{ max: getTodayDate() }}
                    InputLabelProps={{ shrink: true }}
                  />
                </FormControl>
              </Box>
              <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
                <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
                  Customer Details
                </Typography>
                <Box sx={{ position: 'relative' }}>
                  <TextField
                    label="Mobile"
                    name="mobile"
                    fullWidth
                    size="small"
                    value={formData.mobile}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!errors.mobile}
                    helperText={errors.mobile}
                    sx={{ mb: 2 }}
                    required
                  />
                  {isLoadingCustomer && (
                    <CircularProgress 
                      size={20} 
                      sx={{ 
                        position: 'absolute', 
                        right: 8, 
                        top: 8 
                      }} 
                    />
                  )}
                </Box>

                <TextField
                  label="Name"
                  name="name"
                  fullWidth
                  size="small"
                  value={formData.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!errors.name}
                  helperText={errors.name}
                  sx={{ mb: 2 }}
                  required
                />

                <TextField
                  label="Address"
                  name="address"
                  fullWidth
                  multiline
                  rows={3}
                  value={formData.address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!errors.address}
                  helperText={errors.address}
                  sx={{ mb: 2 }}
                  required
                />

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <FormControl sx={{ width: '40%' }}>
                    <Box sx={{ position: 'relative' }}>
                      <TextField
                        label="Pincode"
                        name="pincode"
                        size="small"
                        value={formData.pincode}
                        onChange={handleChange}
                        onBlur={handlePincodeBlur}
                        error={!!errors.pincode}
                        helperText={errors.pincode}
                        required
                      />
                      {isLoadingPincode && (
                        <CircularProgress 
                          size={20} 
                          sx={{ 
                            position: 'absolute', 
                            right: 8, 
                            top: 8 
                          }} 
                        />
                      )}
                    </Box>
                  </FormControl>
                  <FormControl sx={{ width: '25%' }}>
                    <TextField
                      label="Latitude"
                      name="latitude"
                      size="small"
                      value={formData.latitude}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={!!errors.latitude}
                      helperText={errors.latitude}
                    />
                  </FormControl>
                  <FormControl sx={{ width: '25%' }}>
                    <TextField
                      label="Longitude"
                      name="longitude"
                      size="small"
                      value={formData.longitude}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={!!errors.longitude}
                      helperText={errors.longitude}
                    />
                  </FormControl>
                  <IconButton 
                    onClick={handleGoogleMapsSelect}
                    sx={{ 
                      color: 'primary.main',
                      backgroundColor: 'action.hover',
                      '&:hover': {
                        backgroundColor: 'action.selected'
                      },
                      padding: '0px'
                    }}
                  >
                    <LocationOnIcon />
                  </IconButton>
                </Box>
                
                <FormControl fullWidth>
                  <TextField
                    label="City, State"
                    name="cityState"
                    size="small"
                    value={city && state ? `${city}, ${state}` : ''}
                    disabled
                  />
                </FormControl>

                <FormControl fullWidth sx={{ mt: 2 }}>
                  <TextField
                    label="Email"
                    name="email"
                    size="small"
                    value={formData.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!errors.email}
                    helperText={errors.email}
                    required
                  />
                </FormControl>
              </Paper>

              <DialogActions sx={{ justifyContent: 'center', px: 0 }}>
                <Button onClick={resetAllFields} className="custom-cancel-button">
                  Cancel
                </Button>
                <Button type="submit" className="custom-button">
                  Next
                </Button>
              </DialogActions>
            </Box>
          ) : (
            <ItemDetailsForm 
              onSubmit={handleItemSubmit} 
              onBack={handleBack} 
              orderData={orderData}
              onClose={onClose}
              onCancel={resetAllFields}
              items={items}
              setItems={setItems}
              currentItem={currentItem}
              setCurrentItem={setCurrentItem}
              showGst={showGst}
              setShowGst={setShowGst}
              weight={weight}
              setWeight={setWeight}
              crates={crates}
              setCrates={setCrates}
              cod={cod}
              setCod={setCod}
              logisticsCost={logisticsCost}
              setLogisticsCost={setLogisticsCost}
              grandTotal={grandTotal}
              setGrandTotal={setGrandTotal}
              dimensions={dimensions}
              setDimensions={setDimensions}
              deliveryType={deliveryType}
              setDeliveryType={setDeliveryType}
            />
          )}
        </DialogContent>
        <MapModal
          open={mapModalOpen}
          onClose={() => setMapModalOpen(false)}
          onLocationSelect={handleLocationSelect}
          initialLocation={
            formData.latitude && formData.longitude 
              ? { lat: parseFloat(formData.latitude), lng: parseFloat(formData.longitude) } 
              : undefined
          }
        />
      </Dialog>

      <Modal
        open={addressModalOpen}
        onClose={() => setAddressModalOpen(false)}
        aria-labelledby="address-selection-modal"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          height: '80vh',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 1,
          overflow: 'hidden'
        }}>
          <Box sx={{
            flexShrink: 0,
            borderBottom: '1px solid',
            borderColor: 'divider'
          }}>
            <Box sx={{marginLeft: '-180px'}}>
              <Heading
                title='Select Delivery Address' 
                closeIcon='true' 
                onClose={() => setAddressModalOpen(false)}
              />
            </Box>
          </Box>
          <Box sx={{
            overflowY: 'auto',
            flexGrow: 1,
            p: 3
          }}>
            <List>
              {customerAddresses.map((customer, index) => (
                <ListItem key={customer.id || index} disablePadding sx={{ mb: 1 }}>
                  <ListItemButton 
                    onClick={() => handleAddressSelect(customer)}
                    sx={{ 
                      border: '1px solid',
                      borderColor: 'divider',
                      borderRadius: 1,
                      '&:hover': {
                        backgroundColor: 'action.hover',
                        borderColor: 'primary.main'
                      }
                    }}
                  >
                    <ListItemText 
                      primary={`${customer.name} ${customer.email ? `(${customer.email})` : ''}`}
                      secondary={
                        <>
                          <Typography variant="body2" color="text.primary" sx={{ mt: 0.5 }}>
                            {customer.address}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {customer.city ? `${customer.city}, ` : ''}{customer.state} - {customer.pincode}
                          </Typography>
                          {customer.latitude && customer.longitude && (
                            <Typography variant="caption" color="text.secondary">
                              Location: {customer.latitude}, {customer.longitude}
                            </Typography>
                          )}
                        </>
                      }
                    />
                  </ListItemButton>
                </ListItem>
              ))}
              
              <ListItem disablePadding sx={{ mt: 2 }}>
                <ListItemButton 
                  onClick={handleAddNewAddress}
                  sx={{
                    border: '1px dashed',
                    borderColor: 'primary.main',
                    borderRadius: 1,
                    color: 'primary.main',
                    '&:hover': {
                      backgroundColor: 'primary.light',
                      color: 'primary.contrastText'
                    }
                  }}
                >
                  <AddIcon sx={{ mr: 1 }} />
                  <ListItemText primary="Add new address" />
                </ListItemButton>
              </ListItem>
            </List>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default SingleOrderModal;